(function () {
  'use strict';

  window.cgcToggle = function () {
    var p = document.getElementById('cgcPanel');
    if (p.classList.contains('cgc-panel--open')) cgcClose();
    else cgcOpen();
  };

  window.cgcOpen = function () {
    document.getElementById('cgcPanel').classList.add('cgc-panel--open');
  };

  window.cgcClose = function () {
    document.getElementById('cgcPanel').classList.remove('cgc-panel--open');
    cgcShowView('home');
  };

  window.cgcShowView = function (view) {
    var views = ['cgcViewHome', 'cgcViewEarn', 'cgcViewRedeem', 'cgcSublunaSister', 'cgcMatchaMaiden', 'cgcSovereignSiren', 'cgcIslandHeiress'];
    views.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });

    var target = 'cgcViewHome';
    if (view === 'earn') target = 'cgcViewEarn';
    else if (view === 'redeem') target = 'cgcViewRedeem';
    else if (view === 'sublunaSister') target = 'cgcSublunaSister';
    else if (view === 'matchaMaiden') target = 'cgcMatchaMaiden';
    else if (view === 'sovereignSiren') target = 'cgcSovereignSiren';
    else if (view === 'islandHeiress') target = 'cgcIslandHeiress';

    var el = document.getElementById(target);
    if (el) el.style.display = 'block';

    var backBtn = document.getElementById('cgcBackHome');
    if (backBtn) backBtn.classList.toggle('cgc-hero__back--visible', view !== 'home');

    document.getElementById('cgcBody').scrollTop = 0;
  };

  async function loadData() {
    try {
      await Smile.preload(['customerPointsWallet', 'pointsProducts', 'pointsSettings']);

      // Points balance
      var wallet = Smile.customerPointsWallet.preloaded();
      var el = document.getElementById('lunaCoins');
      if (el && wallet) {
        el.textContent = Smile.formatPoints(wallet.balance);
      }

      // Next reward — filter out variable products (pointsPrice null), sort by pointsPrice
      var products = Smile.pointsProducts.preloaded();
      if (products && products.length) {
        var balance = wallet ? wallet.balance : 0;
        var fixed = products.filter(function (p) { return p.pointsPrice !== null; });
        var sorted = fixed.sort(function (a, b) { return a.pointsPrice - b.pointsPrice; });
        var next = sorted.find(function (p) { return p.pointsPrice > balance; }) || sorted[0];

        var row = document.getElementById('cgcNextRewardRow');
        if (row && next && next.reward) {
          var imgSrc = next.reward.imageUrl || '';
          row.innerHTML = '<span class="cgc-row__icon"><img alt="" role="presentation" src="' + imgSrc + '" class="list-item-image"></span>'
            + '<div class="cgc-row__info">'
            + '<div class="cgc-row__label">' + next.reward.name + '</div>'
            + '<div class="cgc-row__value cgc-text__muted">Earn ' + next.pointsPrice.toLocaleString() + ' Luna Coins</div>'
            + '</div>';
        }
      }

    } catch (err) {
      console.error('Smile SDK error:', err);
    }
  }

  function loadReferral() {
    try {
      var customer = Smile.customer ? Smile.customer.current() : null;
      if (!customer) return;

      var refUrl = customer.referralUrl;
      var el = document.getElementById('cgcRefUrl');
      if (el && refUrl) {
        el.value = refUrl;

        var fb = document.getElementById('cgcShareFb');
        var tw = document.getElementById('cgcShareTw');
        var em = document.getElementById('cgcShareEm');
        if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(refUrl);
        if (tw) tw.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(refUrl);
        if (em) em.href = 'mailto:?body=' + encodeURIComponent(refUrl);

        var sharing = document.getElementById('cgcRefSharing');
        if (sharing) sharing.style.display = 'flex';
      }

      // Referral count — hide if not available
      var countEl = document.getElementById('cgcRefCount');
      if (countEl) countEl.closest('div') && (countEl.textContent = '0');

    } catch (err) {
      console.error('Referral load error:', err);
    }
  }

  window.cgcCopyRef = function () {
    var input = document.getElementById('cgcRefUrl');
    var btn = document.getElementById('cgcRefCopy');
    if (!input || !input.value) return;
    navigator.clipboard.writeText(input.value).then(function () {
      btn.classList.add('cgc-ref-code__copy--copied');
      setTimeout(function () { btn.classList.remove('cgc-ref-code__copy--copied'); }, 2000);
    });
  };

  if (window.Smile && window.Smile.customerPointsWallet) {
    loadData();
    loadReferral();
  } else {
    document.addEventListener('smile-js-initialized', function () {
      loadData();
      loadReferral();
    });
  }

})();